import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { mbeConfigService } from './mbe-config.service';
// See C001 - 2026-08-20 - HE
// import { Bank } from '../enum/origin-enum.enum';
import { CreateMerchantSetup, MerchantSetup, MerchantSetupAPI, ServicePointInfo, Bank } from '../model/servicepointsetup';
import { Observable } from 'rxjs';
import { BasicResponse } from '@auth-suite-services/services';

@Injectable({
  providedIn: 'root',
})
export class CreateMerchantSetupService {
  private URL;
  private AmassENSURL;
  headers: HttpHeaders;

  constructor(
    @Inject(mbeConfigService) private config: any,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'PADM').url;
    this.AmassENSURL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'SDSETUP')
        .url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  createCMS(cms: CreateMerchantSetup): Observable<BasicResponse> {
    const headers = this.headers;
    const createCMS = JSON.stringify(cms);
    console.log('Create CMS: ', createCMS);
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/mse/createmse/${cms.relOSPIID ? cms.relOSPIID : 0}`,
      cms,
      { headers }
    );
  }

  getAllSPI(): Observable<ServicePointInfo[]> {
    const headers = this.headers;
    return this.httpClient.get<ServicePointInfo[]>(
      `${this.URL}/spi/getallspi`,
      { headers }
    );
  }

  getNewMerchantNo(): Observable<MerchantSetup> {
    const headers = this.headers;
    return this.httpClient.get<MerchantSetup>(`${this.URL}/mse/newmerchantno`, {
      headers,
    });
  }

  getBank(): Observable<Bank> {
    const headers = this.headers;
    return this.httpClient.get<Bank>(`${this.URL}/mse/getallban`, { headers });
  }
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Changed getBank() Bank type import from '../enum/origin-enum.enum' to '../model/servicepointsetup'. Previous behavior: Imported named export Bank from origin-enum.enum.ts, which only exports OriginEnum (CSP/Bank enum members), causing TS2305 Module has no exported member 'Bank' and failing portaladmin:build. New behavior: Bank comes from servicepointsetup.ts where interface Bank { id, BANRno, bankName } is defined, matching GET /mse/getallban. Reason: Unblock portaladmin development build. Context: /build-and-lint 2026-08-20. Impact: getBank() typing now matches the API row shape; no runtime change. - 2026-08-20 - HE

